module.exports = __webpack_public_path__ + "img/frederick.d754ff0f.jpg";